import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'saveButtonLabel'
})
export class SaveButtonLabelPipe implements PipeTransform {

    transform(path: string): string {
        return path === 'edit-product' ? "Save Product" : "Create Product";
    }

}